import { compile } from 'path-to-regexp';

import type { TOrganizationTypes } from '@sravni/ugc/lib/organizations/types';
import { OrganizationTypes } from '@sravni/ugc/lib/organizations/types';

import { FILTERS_NAME, RATING_TYPES } from '../constants/filters';
import { ORGANIZATION_LIST, ORGANIZATION_MFO_LIST, PRODUCT_LIST } from '../constants/routes';
import { makeQueryParamsFromFilters } from '../helpers/filters';
import type { TFilters } from '../types/filters';

export const generateUrl = (pattern: string, params: TFilters): string => {
  const toPath = compile(pattern);
  return toPath(makeQueryParamsFromFilters(params));
};

export const getOrganizationListRoute = (organizationType: TOrganizationTypes) => {
  let route = ORGANIZATION_LIST;

  if (organizationType === OrganizationTypes.Mfo) {
    route = ORGANIZATION_MFO_LIST;
  }

  return route;
};

export const makeFiltersLink = (filters: TFilters) => {
  let route = PRODUCT_LIST;

  if (filters[FILTERS_NAME.RatingType] === RATING_TYPES.Organizations) {
    route = getOrganizationListRoute(filters[FILTERS_NAME.OrganizationType]);
  }

  const newUrl = generateUrl(route, filters);
  return newUrl;
};
